import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { useLanguage } from '../context/LanguageContext';

const { FiExternalLink, FiCalendar } = FiIcons;

export default function RSVP() {
  const { t } = useLanguage();
  const RSVP_LINK = "https://forms.gle/XCwuPTigQj7faTQ58";

  return (
    <section id="rsvp" className="py-24 lg:py-32 px-4 bg-brand-dark relative overflow-hidden">
      <div className="max-w-4xl mx-auto relative z-10 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="flex flex-col items-center"
        >
          <span className="text-brand-accent text-xs uppercase tracking-[0.4em] font-bold mb-4 block">
            {t('rsvp.label')}
          </span>
          <h2 className="font-serif text-5xl md:text-6xl text-brand-light mb-8">
            {t('rsvp.title')}
          </h2>
          
          <div className="w-12 h-[1px] bg-brand-accent mb-8" />
          
          {/* RSVP Deadline Note */}
          <div className="mb-10 px-6 py-3 bg-brand-accent/20 border border-brand-accent/30 rounded-sm inline-flex items-center gap-3">
            <SafeIcon icon={FiCalendar} className="text-brand-accent text-lg" />
            <span className="text-brand-light text-sm font-medium tracking-wide">
              {t('rsvp.deadline')}
            </span>
          </div>

          <p className="text-brand-light/70 text-lg md:text-xl font-light leading-relaxed mb-12 max-w-2xl">
            {t('rsvp.desc')}
          </p>

          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <a
              href={RSVP_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-4 bg-brand-light text-brand-dark px-12 py-5 rounded-sm font-bold uppercase tracking-[0.3em] text-xs hover:bg-brand-accent hover:text-white transition-all duration-300 shadow-2xl"
            >
              {t('rsvp.button')} <SafeIcon icon={FiExternalLink} className="text-lg" />
            </a>
          </motion.div>

          <p className="mt-8 text-brand-light/40 text-[10px] uppercase tracking-widest font-medium">
            {t('rsvp.redirect')}
          </p>
        </motion.div>
      </div>

      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-64 h-64 border-l border-t border-brand-accent/10 -translate-x-1/2 -translate-y-1/2" />
      <div className="absolute bottom-0 right-0 w-64 h-64 border-r border-b border-brand-accent/10 translate-x-1/2 translate-y-1/2" />
    </section>
  );
}